import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

// Validate Auth0 configuration
if (!domain || !clientId) {
  console.error('⚠️ Auth0 configuration missing!');
  console.error('Please update your .env file with:');
  console.error('- REACT_APP_AUTH0_DOMAIN');
  console.error('- REACT_APP_AUTH0_CLIENT_ID');
  console.error('\nGet these values from: https://manage.auth0.com/dashboard/');
}

const onRedirectCallback = (appState) => {
  console.log('🔄 [Auth0] Redirect callback triggered', appState);
  console.log('🔄 [Auth0] Current URL:', window.location.href);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0Provider
        domain={domain || 'placeholder.auth0.com'}
        clientId={clientId || 'placeholder-client-id'}
        authorizationParams={{
          redirect_uri: window.location.origin,
        }}
        onRedirectCallback={onRedirectCallback}
        useRefreshTokens={true}
        cacheLocation="localstorage"
      >
        <App />
      </Auth0Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
